<template>
  <WsUpdate
    :modelName="modelName"
    :modelVersionName="modelVersionName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="last_version.name"
    :customParentData="customParentData"
    :customUpdateAction="customUpdateAction"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/internal_training_template";
export default {
  data: () => ({
    modelName: model.modelName,
    modelVersionName: model.modelVersionName,
    label: model.label,
    fields: model.fields,
    customParentData: (parentData) => {
      return {
        area: parentData.area,
      };
    },
    customUpdateAction: (modelData) => {
      if (modelData.range_type === "exclusive") {
        modelData.factories = []
      }
      if(modelData.range_type === "general") {
        modelData.exclusive_factories = null
      }
    },
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: ["last_version"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "sequence",
                "areas",
                "industry_categories",
                "system_classes",
                "system_subclasses",
                "range_type",
                "factories",
                "exclusive_factories",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "顯示設定",
              remark: "隱藏的內容將不會顯示於使用者前台介面",
              fields: ["status"],
            },
          ],
        },
      ],
    },
  }),
};
</script>